<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}
.lang-width {
  width: 450px !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">充电桩列表</div>
      <ZD-list-querys>
        <template slot="inputs">
          <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">运营商名称</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.dealName" placeholder="请输入内容" clearable></el-input>
                        </div>
                    </div> -->
          <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">电站名称</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.stationName" placeholder="请输入内容"></el-input>
                        </div>
                    </div> -->
          <div class="list-query-child-div flex">
            <div class="query-title-div">型号名称</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.pileTypeNo"
                clearable
                filterable
                placeholder="可输入查询"
              >
                <el-option
                  v-for="item in pileTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">所属经销商</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.dealNo"
                clearable
                filterable
                placeholder="可输入查询"
              >
                <el-option
                  v-for="item in distributorList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">所属充电网点</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.stationNo"
                clearable
                placeholder="可输入查询"
                filterable
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">版本号</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.softVersion"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电桩编号</div>
            <div class="query-inputs-div flex-1">
              <!-- <el-select class="full-width" v-model="queryInfo.pileCode" filterable size="small" clearable remote reserve-keyword :remote-method="getPileCodeArr" placeholder="请输入4位或4位以上编号">
                                <el-option v-for="item in pileCodeArr" :key="item.pileCode" :label="item.pileCode" :value="item.pileCode"></el-option>
                            </el-select> -->
              <el-input
                size="small"
                v-model="queryInfo.pileCode"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营类型</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.isHostOperate"
                clearable
              >
                <el-option label="代运营" value="01"></el-option>
                <el-option label="自运营" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电桩状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.pileStatusDetailCode"
                clearable
                placeholder="可输入查询"
                filterable
              >
                <el-option
                  v-for="item in pileStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">厂商标识</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.manufactureMark"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电桩类型</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="optType"
                clearable
                @change="handelOptType"
              >
                <el-option :disabled="disabled" label="私有桩" value="01"></el-option>
                <el-option label="公共桩" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">运维状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                  class="full-width"
                  size="small"
                  v-model="queryInfo.repairStatus"
                  clearable
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="正常运营" value="03"></el-option>
                <el-option label="下电" value="04"></el-option>
                
                <el-option label="拆除待注销" value="05"></el-option>
                <el-option label="拆除已注销" value="06"></el-option>
                <!-- <el-option label="已下电" value="07"></el-option> -->
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">本月是否充电</div>
            <div class="query-inputs-div flex-1">
              <el-select
                  class="full-width"
                  size="small"
                  v-model="queryInfo.useStatusCode"
                  clearable
                  @change="handelStatusCodeChange"
              >
                <el-option label="是" value="01"></el-option>
                <el-option label="否" value="02"></el-option>
                
              </el-select>
            </div>
          </div>
         
          <!-- <div class="list-query-child-div flex">
            <div class="query-title-div">是否报修</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.isRepair"
                clearable
              >
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </div>
          </div> -->
          <!-- <div class="list-query-child-div flex">
            <div class="query-title-div">用户反馈</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.userReply"
                clearable
              >
                <el-option label="有" value="Y"></el-option>
                <el-option label="无" value="N"></el-option>
              </el-select>
            </div>
          </div> -->
          <!-- <div class="list-query-child-div flex">
            <div class="query-title-div">创建系统时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                v-model="searchTime"
                style="width: 320px"
                type="daterange"
                size="small"
                value-format="yyyy-MM-dd 00:00:00"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateChange"
              ></el-date-picker>
            </div>
          </div> -->
        </template>
        <template slot="actions">
          <div class="">
            <button
              class="common-bg-button"
              @click="getListData(pagination, true)"
            >
              搜 索
            </button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </div>
          <div class="">
            <button
              class="common-bg-button"
              @click="toExportList"
              style="width: 80px; margin-top: 15px"
            >
              导出
            </button>
          </div>
        </template>
      </ZD-list-querys>
      <div class="page-action-btns flex">
        <!-- <button class="common-bg-button" @click="listDetailFun()">详 情</button> -->
        <button class="common-bg-button" @click="listEditFun()">编 辑</button>
        <!-- <button class="common-bg-button">修改公司</button> -->
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      disabled:false,
      optType:'',
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {
          repairStatus: ''
      }, //初始化数据
      value1: true, //未使用
      operates: {
        width: 220,
        fixed: "right",
        list: [
          // {
          //   id: 'report',
          //   label: '报表',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.id)
          //     this.$store.commit('setPileNo', row.pileNo)
          //     // this.$router.push({
          //     // 	name: pageConfig.reportDetailRouter
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.reportDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          {
            id: "charge",
            label: "充电记录",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
              this.$store.commit("setEditId", row.pileCode);
              // this.$router.push({
              // 	name: pageConfig.chargeDetailRouter
              // });
              window.open(
                this.$router.resolve({ name: pageConfig.chargeDetailRouter })
                  .href,
                "_blank"
              );
            },
          },
          // {
          //   id: 'repair',
          //   label: '维修',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.pileCode)
          //     // this.$router.push({
          //     // 	name: pageConfig.repairListDetail
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.repairListDetail })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          {
            id: "fault",
            label: "故障记录编辑",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
              console.log(row.id)
              this.$store.commit("setEditId", row.pileCode);
              // this.$router.push({
              // 	name: pageConfig.faultDetail
              // });
              window.open(
                this.$router.resolve({ name: pageConfig.faultDetail }).href,
                "_blank"
              );
            },
          },
            {
                id: "devOps",
                label: "运维备注",
                type: "primary",
                show: true,
                disabled: false,
                method: (index, row) => {
                    console.log(row.id)
                    this.$store.commit("setEditId", row.pileCode);
                    // this.$router.push({
                    // 	name: pageConfig.faultDetail
                    // });
                    window.open(
                        this.$router.resolve({ name: pageConfig.operationDetail }).href,
                        "_blank"
                    );
                },
            },
        ],
      }, // 列操作按钮
      searchTime: [], //系统创建时间
      pileCodeArr: [], //废弃
      pileTypeList: [], //桩型号集合
      siteList: [], //站点集合
      distributorList: [], //经销商集合
      pileStatusList: [], //充电桩状态集合
    };
  },
  methods: {
    //查找站点名称 获取数据
    init() {
      if (this.$route.params.stationName) {
        this.queryInfo.stationName = this.$route.params.stationName;
      }
      if (this.$route.query.stationNo) {
        this.queryInfo.stationNo = this.$route.query.stationNo;
      }
      if(this.$route.query.pileCodes){
        this.queryInfo.pileCodes = this.$route.query.pileCodes
        this.getListData(this.pagination, true);
      }
      
      this.getOptions();
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      
      _.queryInfo.pageSize = pagination.pageSize;
      // _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    /**查询select下拉 */
    getOptions() {
      let _ = this;
      //桩型号查询
      _.$H
        .post(_, _.$A.pile.type, { corpNo: "CO1524100773815" })
        .then((res) => {
          if (res.data.data.length > 0) {
            _.pileTypeList = res.data.data.map((item) => {
              return {
                value: item.pileTypeNo,
                label: item.pileTypeCode + "-" + item.pileTypeName,
              };
            });
          }
        });
      //站点查询
      _.$H
        .post(_, _.$A.pile.getSite, { corpNo: "CO1524100773815" })
        .then((res) => {
          if (res.data.data.length > 0) {
            _.siteList = res.data.data.map((item) => {
              return {
                value: item.stationNo,
                label: item.stationName,
              };
            });
          }
        });
      //经销商查询
      _.$H
        .post(_, _.$A.pile.dealer, { corpNo: "CO1524100773815" })
        .then((res) => {
          if (res.data.data.length > 0) {
            _.distributorList = res.data.data.map((item) => {
              return {
                value: item.dealNo,
                label: item.dealName,
              };
            });
          }
        });
      //充电桩状态
      _.$H.post(_, _.$A.config.list, { configType: "307" }).then((res) => {
        if (res.data.data.length > 0) {
          _.pileStatusList = res.data.data.map((item) => {
            return {
              value: item.configVal,
              label: item.configName,
            };
          });
        }
      });
    },
    //改功能已删除
    getPileCodeArr(query) {
      let _ = this;
      if (query.length >= 4) {
        //this.loading = true;
        var obj = {
          sort: "-pileCode",
          pileCode: query,
        };
        _.$H.post(_, _.$A.pile.findPileCodeList, obj).then((res) => {
          _.pileCodeArr = res.data.data;
        });
      } else {
        this.pileCodeArr = [];
      }
    },
    // 页面新增方法
    listAddFun() {
      this.$S.listAddFun(this, pageConfig.tableEditObj);
    },
    // 页面编辑方法
    // listDetailFun() {
    //     this.$S.listEditFun(this, this.selections, pageConfig.tableDetailObj);
    // },
    //页面编辑方法
    listEditFun() {
      let _ = this;
      // this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
      this.$store.commit("setEditId", _.selections[0].pileCode);
      // _.$router.push({
      //     name: 'pileDetail'
      // });
      window.open(this.$router.resolve({ name: "pileDetail" }).href, "_blank");
    },
    //选择时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0];
        this.queryInfo.dtTo = val[1];
      } else {
        delete this.queryInfo.dtFrom;
        delete this.queryInfo.dtTo;
      }
    },
    //下载
    toExportList() {
      // console.log(this.queryInfo)
      let _ = this;
      // if(_.queryInfo.optType != '02'){
      //     _.$U.error('仅支持公共桩导出');
      //     return;
      // }
      // if (_.queryInfo.optType == "" || _.queryInfo.optType == undefined) {
      //   _.$U.error("请选择充电桩类型");
      //   return;
      // }
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.pile.exportPile, _.queryInfo).then((res) => {
        console.log(res.data.data)
        _.$U.saveExcelFile(res.data.data);
        var downUrl =  res.data.data.data;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },
    handelStatusCodeChange(val){
      let _ = this
      if(val){
        _.optType = '02'
        _.queryInfo.optType = '02'
        _.disabled = true
      }else{
        
        _.disabled = false
      }
      
      // if(!_.queryInfo.optType){
      //   _.queryInfo.useStatusCode = ''
      //   _.$message.error('请选择桩类型')
      //   // _.queryInfo.useStatusCode = val
      // }
    },
    handelOptType(val){
      console.log(val);
      let _ = this
       _.queryInfo.optType = val
    },
    //重置
    reset() {
      this.pagination.current = 1;
      delete this.queryInfo.pileTypeNo;
      delete this.queryInfo.dealNo;
      delete this.queryInfo.stationNo;
      delete this.queryInfo.softVersion;
      delete this.queryInfo.pileCode;
      delete this.queryInfo.pileStatusDetailCode;
      delete this.queryInfo.manufactureMark;
      delete this.queryInfo.isHostOperate;
      delete this.queryInfo.useStatusCode;
      delete this.queryInfo.repairStatus;
      delete this.queryInfo.pileCode;
      delete this.queryInfo.optType;
      delete this.queryInfo.isRepair;
      delete this.queryInfo.userReply;
      delete this.queryInfo.dtFrom;
      delete this.queryInfo.dtTo;
      // this.searchTime = [];
      // this.getListData(this.pagination);
      this.tableData = []

    },
  },
  mounted() {
    this.init();
  },
};
</script>
